import { Image, LargeTitle, makeStyles, Subtitle2 } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import sysensqoMinimalLogo from '../../assets/Syensqo-Logo-minimal.svg';
import { FC } from 'react';
import './WelcomeBox.scss';
import { useConversations, useGptConfigurations } from '../../store/hooks';
import { useUserContext } from '../../Contexts/UserContext';
import { useIsMobile } from '../../Hooks/useResponsive';
import { getGptIconAsset } from '../../Utils/image';
import GptMessageBar from '../Common/GptMessageBar';
import { DarkModeIcon } from '../Common/DarkModeIcon';

const styles = makeStyles({
    description: {
        maxWidth: '800px',
        textAlign: 'center'
    }
});

export const WelcomeBox: FC = () => {
    const classes = styles();
    const { t } = useTranslation();
    const { activeGpt } = useConversations();
    const { userProfile } = useUserContext();
    const isMobile = useIsMobile();

    const getFirstName = () => {
        const name = userProfile?.name || userProfile?.username || '';
        if (!name) return '';
        // If name looks like full name, take first token
        return name.split(' ')[1];
    };
    const firstName = getFirstName();

    return (
        <div className='container'>           
            {   // Row containing logo and welcome message inline
                activeGpt?.isDefault?
                    (
                        <div className='welcome-row'>
                            <img src={sysensqoMinimalLogo} alt='Syensqo Logo' className='welcome-logo inline-logo' />
                            <h1 className='welcome-title inline-title'>
                                {isMobile
                                    ? t('WelcomeBox.Welcome.Mobile')
                                    : t('WelcomeBox.Welcome', { firstName })
                                }
                            </h1>
                        </div>
                    ):
                    (
                        <div className='welcome-gpt-row'> 
                            <DarkModeIcon 
                                src={getGptIconAsset(activeGpt?.icon)}
                                alt="Personal GPT"
                                className='welcome-gpt-icon'
                                width='30px'
                                height='30px'
                            />
                            <h1  className='welcome-gpt-title'>{activeGpt?.name}</h1>
                            <p  className='welcome-gpt-description'>{activeGpt?.description}</p>
                        </div>
                    )
            }

            {activeGpt?.disclaimer &&
                <GptMessageBar title='Note' text={activeGpt?.disclaimer} />
            }
        </div>
    );
};
